var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeAppMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 23.832H29.1666V29.6654H23.3333V23.832ZM14.5833 23.832H20.4166V29.6654H14.5833V23.832ZM5.83331 23.832H11.6666V29.6654H5.83331V23.832ZM23.3333 15.082H29.1666V20.9154H23.3333V15.082ZM14.5833 15.082H20.4166V20.9154H14.5833V15.082ZM5.83331 15.082H11.6666V20.9154H5.83331V15.082ZM23.3333 6.33203H29.1666V12.1654H23.3333V6.33203ZM14.5833 6.33203H20.4166V12.1654H14.5833V6.33203ZM5.83331 6.33203H11.6666V12.1654H5.83331V6.33203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeAppMenu);
export default __webpack_public_path__ + "static/media/fe_app-menu.b0f4fdffa7c90f30012c48b148b7ae67.svg";
export { ForwardRef as ReactComponent };